import {
  init as initSentry,
  browserTracingIntegration,
  replayIntegration,
} from '@sentry/vue'

export default function initializeSentry({
  nuxtApp,
  dsn,
  replayNetworkDetailAllowUrls,
  sendDefaultPii,
}) {
  const { public: config } = useRuntimeConfig()
  if (config.env === 'prod') {
    console.log = function () {}
    console.debug = function () {}
  }

  const { vueApp } = nuxtApp
  initSentry({
    app: vueApp,
    attachProps: true,
    timeout: 2000,
    replaysSessionSampleRate: config.env === 'prod' ? 0.2 : 0,
    replaysOnErrorSampleRate: 1.0,
    environment: config.env,
    dsn,
    enabled: !!config.githubSha,
    integrations: [
      browserTracingIntegration(),
      replayIntegration({
        maskAllText: false,
        networkDetailAllowUrls: replayNetworkDetailAllowUrls,
      }),
    ],
    sendDefaultPii,
    trackComponents: true,
    tracesSampleRate: 0.3,
    release: config.githubSha,
    beforeSend(event, hint) {
      const error = hint.originalException
      if (error?.message) {
        if (error.message.includes('401') || error.message.includes('403'))
          return null // expired session
        if (
          error.message.includes('Unable to preload CSS for') ||
          error.message.includes('Failed to fetch dynamically imported')
        )
          return null // https://app.asana.com/0/1200020896163673/1205516640363406/f
      }
      return event
    },
  })
}
